module.exports = __webpack_public_path__ + "img/techalliance-poster-1.5af38be7.jpg";